"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = exports.get = void 0;
const _LOCAL_STORAGE_KEY = `browserless-debugger:` + window.location.origin + window.location.pathname;
const hasLocalStorage = (() => {
    let can = false;
    try {
        window.localStorage.getItem(_LOCAL_STORAGE_KEY);
        can = true;
    }
    catch (e) {
        console.error(`Error writing to local-storage: ${e}`);
        can = false;
    }
    return can;
})();
const state = (() => {
    const prior = hasLocalStorage ? window.localStorage.getItem(_LOCAL_STORAGE_KEY) : '{}';
    let priorState;
    try {
        priorState = JSON.parse(prior || '{}');
    }
    catch (_a) {
        priorState = {};
    }
    return priorState;
})();
const writeState = (value) => {
    if (hasLocalStorage) {
        window.localStorage.setItem(_LOCAL_STORAGE_KEY, JSON.stringify(value));
    }
};
const get = (key) => state.hasOwnProperty(key) ? state[key] : null;
exports.get = get;
const set = (key, value) => {
    state[key] = value;
    writeState(state);
    return value;
};
exports.set = set;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zdG9yYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQU0sa0JBQWtCLEdBQUcsdUJBQXVCLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFDLFFBQVEsQ0FBQyxRQUFRLENBQUM7QUFDdkcsTUFBTSxlQUFlLEdBQUcsQ0FBQyxHQUFHLEVBQUU7SUFDNUIsSUFBSSxHQUFHLEdBQUcsS0FBSyxDQUFDO0lBRWhCLElBQUk7UUFDRixNQUFNLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDO1FBQ2hELEdBQUcsR0FBRyxJQUFJLENBQUM7S0FDWjtJQUFDLE9BQU0sQ0FBQyxFQUFFO1FBQ1QsT0FBTyxDQUFDLEtBQUssQ0FBQyxtQ0FBbUMsQ0FBQyxFQUFFLENBQUMsQ0FBQztRQUN0RCxHQUFHLEdBQUcsS0FBSyxDQUFDO0tBQ2I7SUFFRCxPQUFPLEdBQUcsQ0FBQztBQUNiLENBQUMsQ0FBQyxFQUFFLENBQUM7QUFFTCxNQUFNLEtBQUssR0FBd0IsQ0FBQyxHQUFHLEVBQUU7SUFDdkMsTUFBTSxLQUFLLEdBQUcsZUFBZSxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxrQkFBa0IsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7SUFDdkYsSUFBSSxVQUFrQyxDQUFDO0lBRXZDLElBQUk7UUFDRixVQUFVLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLElBQUksSUFBSSxDQUFDLENBQUM7S0FDeEM7SUFBQyxXQUFNO1FBQ04sVUFBVSxHQUFHLEVBQUUsQ0FBQztLQUNqQjtJQUVELE9BQU8sVUFBVSxDQUFDO0FBQ3BCLENBQUMsQ0FBQyxFQUFFLENBQUM7QUFFTCxNQUFNLFVBQVUsR0FBRyxDQUFDLEtBQTBCLEVBQUUsRUFBRTtJQUNoRCxJQUFJLGVBQWUsRUFBRTtRQUNuQixNQUFNLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxrQkFBa0IsRUFBRSxJQUFJLENBQUMsU0FBUyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUM7S0FDeEU7QUFDSCxDQUFDLENBQUE7QUFFTSxNQUFNLEdBQUcsR0FBRyxDQUFDLEdBQVcsRUFBRSxFQUFFLENBQUMsS0FBSyxDQUFDLGNBQWMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUM7QUFBckUsUUFBQSxHQUFHLE9BQWtFO0FBRTNFLE1BQU0sR0FBRyxHQUFHLENBQUksR0FBVyxFQUFFLEtBQU8sRUFBSyxFQUFFO0lBQ2hELEtBQUssQ0FBQyxHQUFHLENBQUMsR0FBRyxLQUFLLENBQUM7SUFDbkIsVUFBVSxDQUFDLEtBQUssQ0FBQyxDQUFDO0lBRWxCLE9BQU8sS0FBSyxDQUFDO0FBQ2YsQ0FBQyxDQUFDO0FBTFcsUUFBQSxHQUFHLE9BS2QifQ==